import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../services';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  private count = 0;

  constructor(private loaderService: LoaderService) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(req.headers.get('x-loader') === 'false'){
      // remove the header to prevent it from being sent to the server
      const modifiedReq = req.clone({
        headers: req.headers.delete('x-loader')
      });

      return next.handle(modifiedReq);
    }
    if (this.count === 0) {
      this.loaderService.showLoader();
    }
    this.count++;
    const modifiedReq = req.clone({
      headers: req.headers.delete('x-loader')
    });
    return next.handle(modifiedReq).pipe(
      finalize(() => {
        this.count--;
        if (this.count === 0) {
          this.loaderService.hideLoader();
        }
      }));
  }
}